export interface TriggerButtonInfo {
  buttonID: string
  singularName: string
  apiID: string
  label: string
  plugin: string
  routerApi: string
  environment: string
  variant?: string
  roles?: string[]
}

export interface GithubActionEnabledResponse {
  enabled: boolean
  buttons: TriggerButtonInfo[]
}

export enum DeploymentType {
  NOTIFICATION_PRODUCTION = 'notification_production',
  NOTIFICATION_DEVELOPMENT = 'notification_development',
}

export const actionTypes = {
  'notification_production': 'Send notification production',
  'notification_development': 'Send notification development',
}
